import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _HeaderThemeView;
import { createSlice } from '@reduxjs/toolkit';
export var EHeaderTheme;
(function (EHeaderTheme) {
  EHeaderTheme["primary"] = "primary";
  EHeaderTheme["secondary"] = "secondary";
  EHeaderTheme["dark"] = "dark";
})(EHeaderTheme || (EHeaderTheme = {}));
export var HeaderThemeView = (_HeaderThemeView = {}, _defineProperty(_HeaderThemeView, EHeaderTheme.primary, 'secondary'), _defineProperty(_HeaderThemeView, EHeaderTheme.secondary, 'secondary-invert'), _defineProperty(_HeaderThemeView, EHeaderTheme.dark, 'tertiary'), _HeaderThemeView);
var initialState = {
  isWebView: false,
  isRegionConfirmationShow: false,
  theme: EHeaderTheme.secondary,
  isBannerHidden: false,
  overlayDisabled: false
};
var layoutSlice = createSlice({
  name: 'menu',
  initialState: initialState,
  reducers: {
    setHeaderTheme: function setHeaderTheme(state, _ref) {
      var payload = _ref.payload;
      state.theme = payload;
    },
    setIsBannerHidden: function setIsBannerHidden(state, _ref2) {
      var payload = _ref2.payload;
      state.isBannerHidden = payload;
    },
    setIsRegionConfirmationShow: function setIsRegionConfirmationShow(state, _ref3) {
      var payload = _ref3.payload;
      state.isRegionConfirmationShow = payload;
    },
    setIsHeaderOverlayDisabled: function setIsHeaderOverlayDisabled(state, _ref4) {
      var payload = _ref4.payload;
      state.overlayDisabled = payload;
    }
  }
});
var _layoutSlice$actions = layoutSlice.actions,
  setHeaderTheme = _layoutSlice$actions.setHeaderTheme,
  setIsBannerHidden = _layoutSlice$actions.setIsBannerHidden,
  setIsRegionConfirmationShow = _layoutSlice$actions.setIsRegionConfirmationShow,
  setIsHeaderOverlayDisabled = _layoutSlice$actions.setIsHeaderOverlayDisabled;
export { setHeaderTheme, setIsBannerHidden, setIsRegionConfirmationShow, setIsHeaderOverlayDisabled };
export var layout = layoutSlice.reducer;